import React, {useEffect, useRef} from 'react';

type MHHandleOutsideClick = {
    action?: (value?: boolean) => void;
    className?: string;
    'data-testid'?: string;
    children: React.ReactNode;
};

const HandleOutsideClick = ({action, className, 'data-testid': dataTestId, children}: MHHandleOutsideClick) => {
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    const wrapperRef = useRef(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {
            action && action();
        }
    };

    return (
        <div ref={wrapperRef} className={className} data-testid={dataTestId}>
            {children}
        </div>
    );
};

export default HandleOutsideClick;
